import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72447d1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseMenu',
  setup(__props) {

const isMenuOpen = ref(false);

const clickOutside = () => {
  if (isMenuOpen.value) {
    isMenuOpen.value = false;
  }
};
const handleClick = () => {
  isMenuOpen.value = !isMenuOpen.value;
  if (isMenuOpen.value) {
    const menu: HTMLInputElement | null = document.querySelector('#menu-dropdown');

    if (menu) {
      const screenHeight = window.innerHeight;
      const topPosition = menu.getBoundingClientRect().top;
      const heightMenu = menu.getBoundingClientRect().height;

      if (topPosition + heightMenu > screenHeight) {
        menu.style.bottom = '50px';
      }
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{ open: isMenuOpen.value }, "menu-btn"]),
      onClick: handleClick
    }, _hoisted_3, 2),
    _createElementVNode("div", {
      id: "menu-dropdown",
      class: _normalizeClass([{ show: isMenuOpen.value }, "menu-dropdown"])
    }, [
      _renderSlot(_ctx.$slots, "menuItems", {
        events: { handleClick: handleClick }
      })
    ], 2)
  ])), [
    [_directive_click_outside, clickOutside]
  ])
}
}

})